// *******************************************************************************
// Newsletter form validation
// *******************************************************************************

document.addEventListener('DOMContentLoaded', () => {
  const newsletterFormModule = document.querySelector('.newsletter-module');
  const newsletterForm = document.getElementById('newsletter-module__form');
  if (newsletterForm) {
    const formAction = document.querySelector('#action');
    const formNonce = document.querySelector('#nonce');
    const recaptchaElem = document.querySelector('[data-sitekey]');
    const recaptchaKey = recaptchaElem.getAttribute('data-sitekey');
    const submitButton = newsletterForm.querySelector('.newsletter-module__submit-btn');
    const fv = FormValidation.formValidation(newsletterForm, {
      locale: 'sl_SI',
      localization: FormValidation.locales.sl_SI,
      fields: {
        email: {
          validators: {
            emailAddress: {
              message: 'The value is not a valid email address',
            },
          },
        },
      },
      plugins: {
        message: new FormValidation.plugins.Message({
          container: (field, element) => element.closest('.mod-input,.checkbox,.dropdown'),
        }),
        declarative: new FormValidation.plugins.Declarative({
          html5Input: true,
        }),
        trigger: new FormValidation.plugins.Trigger(),
        submitButton: new FormValidation.plugins.SubmitButton(),
      },
    })
      .on('core.element.validated', (e) => {
        // e.element presents the field element
        // e.valid indicates the field is valid or not

        // Get the field value
        const value = fv.getElementValue(e.field, e.element);
        const container = FormValidation.utils.closest(e.element, '.mod-input, .checkbox');
        if (value === '') {
          FormValidation.utils.classSet(container, {
            'is-validation-failed': true,
          });
        } else {
          FormValidation.utils.classSet(container, {
            'is-validation-failed': false,
          });
        }

        if (!e.valid) {
          FormValidation.utils.classSet(container, {
            'is-validation-failed': true,
          });
        } else {
          FormValidation.utils.classSet(container, {
            'is-validation-failed': false,
          });
        }
      })
      .on('core.form.valid', () => {
        grecaptcha.ready(() => {
          grecaptcha.execute(recaptchaKey, { action: formAction.value }).then((token) => {
            // Ajax check if valid
            const formData = {};
            const formDataInput = new FormData();
            document.querySelector('.loading')?.classList.add('is-active');
            newsletterForm.querySelectorAll('input, textarea').forEach((input) => {
              formData[input.name] = input.value.trim();
            });

            formData.title = newsletterForm.querySelector('.dropdown__placeholder-text').innerHTML;

            // Append the text fields
            formDataInput.append('action', formAction.value);
            formDataInput.append('nonce', formNonce.value);
            formDataInput.append('token', token);
            formDataInput.append('id', localData.id);
            formDataInput.append('lang', localData.lang);
            formDataInput.append('inputs', JSON.stringify(formData));
            submitButton.disabled = true;

            axios
              .post(localData.siteURL, formDataInput, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              })
              .then((response) => {
                document.querySelector('.loading')?.classList.remove('is-active');
                submitButton.disabled = false;
                if (response.status === 200) {
                  newsletterFormModule.classList.add('show-thankyou');
                } else {
                  newsletterFormModule.innerHTML = `<div>${response.data.data.msg}</div>`;
                }
                newsletterFormModule.scrollIntoView({ behavior: 'smooth', block: 'center' });
              })
              .catch((err) => {
                if (err.response.status === 409) {
                  newsletterForm.querySelector('#error-message-place').innerHTML = err.response.data.data.msg;
                }
                document.querySelector('.loading')?.classList.remove('is-active');
                submitButton.disabled = false;
                // console.log(err);
              });
          });
        });
      });
  }
});
